<template>
	<div v-if="type">
		<p v-if="date" class="date">{{date}}</p>
		<div class="message flex" :class="{'flex-reverse': mine}">
			<div class="icon flex-center">
				<img :src="message.avatar">
			</div>
			<div class="flex-grow flex-column" :class="{'flex-start': !mine, 'flex-start-end': mine}">
				<div v-if="!mine" class="name flex-center">
					<p class="ellipsis">{{message.nick}}</p>
					<div v-if="memberType" class="tag" :style="{'background': memberType[1]}">{{memberType[0]}}</div>
				</div>
				<div v-if="type == 'text'" class="text" :style="{'color': mine ? '#fff' : '#000', 'background': mine ? '#0284FF' : '#fff'}">{{content}}</div>
				<div v-else-if="type == 'image'" class="image flex-center" :style="{'height': `${Math.min(300, 200 / params.width * params.height)}px`}" @click="$preview({src: content})">
					<img :src="content" alt="">
				</div>
				
				<div v-else-if="type == 'product'" class="card flex-center" @click="cardHandle">
					<div class="card-image flex-center">
						<img :src="params.image" alt="">
					</div>
					<div class="card-info flex-grow flex-column">
						<p class="card-name ellipsis-2 flex-grow">{{params.name}}</p>
						<span class="card-sum">￥{{params.sum}}</span>
					</div>
				</div>
				<div v-else-if="type == 'order'" class="card flex-center" @click="cardHandle">
					<div class="card-image flex-center">
						<img :src="params.image" alt="">
					</div>
					<div class="card-info flex-grow flex-column">
						<p class="card-name ellipsis-2 flex-grow">{{params.name}}</p>
						<div class="card-sum flex-baseline">
							<span class="card-sum-label">订单金额：</span>
							<span>￥{{params.sum}}</span>
						</div>
					</div>
				</div>
				<div v-else-if="type == 'refund'" class="card flex-center" @click="cardHandle">
					<div class="card-image flex-center">
						<img :src="params.image" alt="">
					</div>
					<div class="card-info flex-grow flex-column">
						<p class="card-name ellipsis-2 flex-grow">{{params.name}}</p>
						<div class="card-sum flex-baseline">
							<span class="card-sum-label">退款金额：</span>
							<span>￥{{params.sum}}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {mapState} from 'vuex'

	const TencentCloudChat = window.opener.TencentCloudChat;
	
	export default {
		props: {
			memberType: Array,
			prev: Object,
			message: Object
		},
		
		computed: {
			...mapState(['userInfo']),
			
			prevType() {
				if (!this.prev) return '';
				return this.prev.payload.description;
			},
			
			type() {
				return this.message.payload.description;
			},
			
			date() {
				return !this.prevType || this.message.time - this.prev.time > 120 ? new Date(this.message.time * 1000).format('MM-dd hh:mm') : '';
			},
			
			content() {
				return this.message.payload.data;
			},
			
			params() {
				return JSON.parse(this.message.payload.extension || '{}');
			},
			
			mine() {
				return this.message.from == TencentCloudChat.userID;
			}
		},

		methods: {
			cardHandle() {
				if (this.type == 'product') {

				} else if (this.type == 'order') {
					this.$parent.postMessage('order', this.content);
				} else if (this.type == 'refund') {
					this.$parent.postMessage('refund', this.content);
				}
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.date {
		padding-top: 10px;
		text-align: center;
		font-size: 12px;
		color: #95A0A4;
	}
	
	.message {
		gap: 8px;
		padding: 10px 20px;
		
		.icon {
			width: 40px;
			height: 40px;
			border-radius: 8px;
			background: #fff;
		}
		
		.name {
			max-width: 100%;
			margin-bottom: 5px;
			line-height: 24px;
			font-size: 13px;
			color: #666;
				
			.tag {
				border-radius: 4px;
				padding: 0 4px;
				margin-left: 8px;
				line-height: 18px;
				font-size: 12px;
				white-space: nowrap;
				color: #fff;
			}
		}
		
		.text {
			border-radius: 6px;
			padding: 8px 14px;
			line-height: 22px;
			font-size: 14px;
			white-space: pre-wrap;
			word-break: break-all;
		}
		
		.image {
			width: 200px;
			border-radius: 6px;
			overflow: hidden;
			cursor: pointer;

			img {
				width: 100%;
				max-height: none;
			}
		}
		
		.card {
			gap: 10px;
			box-sizing: border-box;
			width: 300px;
			border-radius: 6px;
			padding: 10px;
			background: #fff;
			cursor: pointer;
			
			&-image {
				width: 96px;
				height: 75px;
				border-radius: 6px;
				background: #F5F5F5;
			}
			
			&-info {
				gap: 10px;
			}
		
			&-name {
				height: 40px;
				line-height: 20px;
				font-size: 13px;
				word-break: break-all;
				color: #1A2938;
			}
		
			&-sum {
				font-size: 15px;
				font-weight: 400;
				color: #FF6900;
				
				&-label {
					font-size: 13px;
					color: #999;
				}
			}
		}
	}
</style>
